import { memo } from "react";

import Carousel from "@/design-system/carousel";
import { sendTelemetryEvent } from "@/lib/telemetry";
import { useViewportInfoContext } from "@/src/contexts";
import type { PropsWithStyleX } from "@/styles/tokens.stylex";
import { BrandEventType, type TelemetryClickFromType, TelemetryEntity } from "@Components/Modules/Helpers";
import * as stylex from "@stylexjs/stylex";

import type { IDiscountTile } from "./DiscountTile";
import DiscountTile from "./DiscountTile";

export interface IDiscountsCarousel extends PropsWithStyleX {
    discounts: IDiscountTile[];
    disableLazyLoading?: boolean;
    origin?: TelemetryClickFromType;
}

export const DiscountsCarousel = memo(
    (props: IDiscountsCarousel) => {
        const { isMobile, isMobileOrTablet } = useViewportInfoContext();

        const onMobileSlide = () => {
            if (props.discounts?.length > 0) {
                sendTelemetryEvent({
                    eventName: TelemetryEntity.Brand + BrandEventType.BrandHorizontalSwipe,
                    actionType: "Swipe",
                    itemId: props.discounts[0].brandId,
                    origin: props.origin,
                });
            }
        };

        return (
            <Carousel
                styleX={[styles.discountsCarouselComponent, props.styleX]}
                itemsToShow={isMobileOrTablet ? 1 : 2}
                showArrows={!isMobile}
                onMobileSlide={onMobileSlide}
                fullWidth={isMobile}
            >
                {props.discounts.map((d) => (
                    <DiscountTile key={d.id} {...d} origin={props.origin} />
                ))}
            </Carousel>
        );
    },
    (prevProps, nextProps) => prevProps.discounts.length === nextProps.discounts.length,
);

const styles = stylex.create({
    discountsCarouselComponent: {},
});
